export default {
  SET_DASHBOARD_CONFIG(state, configDashboard) {
    state.dashboardConfig = configDashboard;
  },
  SET_DEFAULT_DASHBOARD(state, guid) {
    state.defaultDashboard = guid;
  },
  SET_SELECTED_DASHBOARD(state, dashboard) {
    state.selectedDashboard = dashboard;
  },
  SET_DASHBOARD_ITEMS(state, { items, type }) {
    state.dashboardItems[type] = items;
  },
  SAVE_SELECTED_DASHBOARD(state, dashboard) {
    state.selectedDashboard = dashboard;
  },
  SET_DASHBOARD_LOADING(state, { area, loading }) {
    state.dashboardLoading[area] = loading;
  },
};
